import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const CriticalIcon = (props) => {
  const { themeName, getThemeColor,getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9.0835 11.25H10.5835V12.75H9.0835V11.25ZM9.0835 5.25H10.5835V9.75H9.0835V5.25ZM9.826 1.5C5.686 1.5 2.3335 4.86 2.3335 9C2.3335 13.14 5.686 16.5 9.826 16.5C13.9735 16.5 17.3335 13.14 17.3335 9C17.3335 4.86 13.9735 1.5 9.826 1.5ZM9.8335 15C6.5185 15 3.8335 12.315 3.8335 9C3.8335 5.685 6.5185 3 9.8335 3C13.1485 3 15.8335 5.685 15.8335 9C15.8335 12.315 13.1485 15 9.8335 15Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default CriticalIcon;
